import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ErrorData } from '@types';

// eslint-disable-next-line no-shadow
export enum SendBroadcastStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export type SendBroadcastState = {
  loading: SendBroadcastStatus;
  error?: ErrorData;
  broadcastId?: string;
};

const initialState: SendBroadcastState = {
  loading: SendBroadcastStatus.IDLE,
  error: undefined,
  broadcastId: undefined,
};

export const whatsAppSendBroadcastSlice = createSlice({
  name: 'whatsAppSendBroadcast',
  initialState,
  reducers: {
    sendBroadcast(
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: PayloadAction<{
        botAccountId: number;
        auditId: string;
        scheduledAt?: string;
      }>
    ) {
      state.loading = SendBroadcastStatus.PENDING;
      state.error = undefined;
    },
    sendBroadcastSuccess(
      state,
      action: PayloadAction<{ broadcastId: string }>
    ) {
      state.loading = SendBroadcastStatus.SUCCESS;
      state.broadcastId = action.payload.broadcastId;
    },
    sendBroadcastFailure(state, action: PayloadAction<ErrorData>) {
      state.loading = SendBroadcastStatus.FAILURE;
      state.error = action.payload;
    },
    clearSendBroadcast(state) {
      state.loading = SendBroadcastStatus.IDLE;
      state.error = undefined;
      state.broadcastId = undefined;
    },
  },
});

export const {
  sendBroadcast,
  sendBroadcastSuccess,
  sendBroadcastFailure,
  clearSendBroadcast,
} = whatsAppSendBroadcastSlice.actions;

export default whatsAppSendBroadcastSlice.reducer;
